export enum OperatingSystem {
  ANDROID,
  IOS,
  OTHERS,
}

export const osDetector = () => {
  if(typeof window !== "undefined") {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("android") > -1) return OperatingSystem.ANDROID;
    if (userAgent.indexOf("iphone") > -1 || userAgent.indexOf("ipad") > -1) return OperatingSystem.IOS;
  }
  return OperatingSystem.OTHERS;
}